var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showComputed)?_c('span',[_vm._v(" Parola trebuie să conțină cel puțin 8 caractere, o literă mare, o literă mică, un simbol si un număr. ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }